// import Swiper JS
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules'
// import Swiper styles
import 'swiper/css';

// init Swiper:
const carousel = () => {
  new Swiper('.swiper', {
    modules: [Navigation],
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 640px
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 20
        }
    },
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};

export default carousel;
